module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }), _c('div', {
    staticClass: "title-frontMatter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“Dex, wait! Haven’t you forgotten something? Your ring.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“Keep it,” he said bitingly. “A memento of a failed affair. Unless, of course, you want to pay for it in kind. Unlike the dozens before me, I still have not seen your bedroom.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This mocking cynicism was the last straw. Flinging the ring at him, she yelled, “Get out! Go, go!”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“No one tells me to leave,” he stated softly.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“Until now,” she shot back.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“Never ever,” he drawled quietly. “And certainly not a devious little girl like you, who doesn’t know whether she wants to jilt me or jump me. I think we really need to know the answer, Bethany. Don’t you?”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46215a06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459251816_fm01.vue
// module id = 60
// module chunks = 0